import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=6a6d6d43"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports